import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
var CHIP_GAP = 8;
var MAX_ROW_WIDTH = { xs: '100%', sm: '280px', md: '440px', lg: '600px', xl: '820px' };
var ActiveFilterChipsRow = function (_a) {
    var chips = _a.chips, onOverflowClick = _a.onOverflowClick, onClearAll = _a.onClearAll;
    var budgetRef = useRef(null);
    var chipMeasureRefs = useRef([]);
    var overflowMeasureRef = useRef(null);
    var clearMeasureRef = useRef(null);
    var _b = useState(chips.length), visibleCount = _b[0], setVisibleCount = _b[1];
    var overflowPlaceholder = "+".concat(Math.max(chips.length, 1));
    useLayoutEffect(function () {
        var budgetEl = budgetRef.current;
        if (!budgetEl)
            return;
        var recompute = function () {
            var _a, _b, _c, _d, _e;
            var availableWidth = budgetEl.clientWidth;
            var clearWidth = (_b = (_a = clearMeasureRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0;
            var overflowWidth = (_d = (_c = overflowMeasureRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth) !== null && _d !== void 0 ? _d : 0;
            var usedWidth = clearWidth > 0 ? clearWidth + CHIP_GAP : 0;
            var count = 0;
            for (var i = 0; i < chips.length; i++) {
                var chipWidth = (_e = chipMeasureRefs.current[i]) === null || _e === void 0 ? void 0 : _e.offsetWidth;
                if (chipWidth === undefined)
                    break;
                var isLastChip = i === chips.length - 1;
                var reserveForOverflow = isLastChip ? 0 : overflowWidth + CHIP_GAP;
                var widthWithThisChip = usedWidth + chipWidth + (i > 0 ? CHIP_GAP : 0);
                if (widthWithThisChip + reserveForOverflow <= availableWidth) {
                    usedWidth = widthWithThisChip;
                    count += 1;
                }
                else {
                    break;
                }
            }
            setVisibleCount(count);
        };
        recompute();
        var observer = new ResizeObserver(recompute);
        observer.observe(budgetEl);
        return function () { return observer.disconnect(); };
    }, [chips, overflowPlaceholder]);
    var overflowCount = chips.length - visibleCount;
    var measuredChips = useMemo(function () { return chips; }, [chips]);
    if (chips.length === 0) {
        return null;
    }
    return (React.createElement(Box, { sx: { position: 'relative', minWidth: 0 } },
        React.createElement(Box, { ref: budgetRef, "aria-hidden": true, sx: { position: 'absolute', visibility: 'hidden', pointerEvents: 'none', width: MAX_ROW_WIDTH } }),
        React.createElement(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                gap: "".concat(CHIP_GAP, "px"),
                minWidth: 0,
                maxWidth: MAX_ROW_WIDTH,
                overflow: 'hidden',
            } },
            React.createElement(Box, { "aria-hidden": true, sx: {
                    position: 'absolute',
                    visibility: 'hidden',
                    pointerEvents: 'none',
                    top: -9999,
                    left: -9999,
                    display: 'flex',
                    gap: "".concat(CHIP_GAP, "px"),
                } },
                measuredChips.map(function (chip, index) { return (React.createElement(Box, { key: chip.id, ref: function (node) { chipMeasureRefs.current[index] = node; } },
                    React.createElement(FilterChip, { label: chip.label, onRemove: function () { } }))); }),
                React.createElement(Box, { ref: overflowMeasureRef },
                    React.createElement(FilterChip, { label: overflowPlaceholder, onClick: function () { } }))),
            chips.slice(0, visibleCount).map(function (chip) { return (React.createElement(FilterChip, { key: chip.id, label: chip.label, onRemove: chip.onRemove })); }),
            overflowCount > 0 && (React.createElement(FilterChip, { label: "+".concat(overflowCount), onClick: onOverflowClick })))));
};
export default ActiveFilterChipsRow;
